import { useTranslation } from "react-i18next";
import { CalendarDays, List } from "lucide-react";
import { ToggleGroup } from "@/components/ui";
import type { BookingsViewMode } from "./bookingsViewPreference";
import { cn } from "@/lib/utils";

interface BookingsViewToggleProps {
  viewMode: BookingsViewMode;
  onViewModeChange: (mode: BookingsViewMode) => void;
  className?: string;
}

/** Calendar / list switch — place next to the bookings results, not the page title. */
export function BookingsViewToggle({
  viewMode,
  onViewModeChange,
  className,
}: BookingsViewToggleProps) {
  const { t } = useTranslation("bookings");

  return (
    <ToggleGroup
      variant="segmented"
      size="sm"
      className={cn(
        "hidden w-auto shrink-0 sm:inline-flex sm:[&_button]:flex-none",
        className,
      )}
      value={viewMode}
      onChange={onViewModeChange}
      ariaLabel={t("viewSelectorLabel")}
      options={[
        {
          value: "calendar",
          label: t("viewCalendar"),
          icon: CalendarDays,
        },
        {
          value: "list",
          label: t("viewList"),
          icon: List,
        },
      ]}
    />
  );
}
